/* globals define */
/*
  Purpose:
    - UI controller for the flyout.

  Dependencies
    - Mustache
    - jQuery
    - THD Namespace
*/
(function closure(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('header.simpleflyout', ['jquery', 'mustache', 'header.data', 'header.analytics', 'header.mask'],
      function load(jQuery, Mustache, headerData, headerAnalytics, headerMask) {
        return factory(root, jQuery, Mustache, headerData, headerAnalytics, headerMask);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.flyout = factory(root, jQuery, Mustache, THD.HFApp.data, THD.HFApp.analytics);
    /*eslint-enable*/
  }
})(this, function factory(root, $, Mustache, headerData, headerAnalytics, headerMask) {
  var flyout = {};

  var privateMethods = {};
  var privateData = {};

  var homeDecorFurnitureData = {};
  var diyProjectsIdeasData = {};
  var homeServicesData = {};

  var l1Name;
  var l2Name;

  privateMethods.templates = {};

  // constructDIYProjectsIdeasFlyoutLevel1
  // constructHomeServicesFlyoutLevel1
  // The id contains level 2 even though this is level 1
  privateMethods.templates.diyAndHomeServicesLevel1 =
    '<div id="diyhslevel2" class="diyandhs">' +
    '  <span class="SimpleFlyout__header">' +
    '    {{name}} ' +
    '  </span>' +
    '  <div class="SimpleFlyout__divider"></div>' +
    '  <ul class="SimpleFlyout__list">' +
    '    {{#links}} ' +
    '      {{#hidel2level}} ' +
    '        {{#sublinks}} ' +
    '          {{^hidemobile}} ' +
    '            <li class="SimpleFlyout__listItem">' +
    '              <a data-type="direct" ' +
    '                 class="SimpleFlyout__link" ' +
    '                 href="{{link}}" ' +
    '                 title="{{{title}}}">' +
    '                {{{title}}} ' +
    '              </a>' +
    '            </li>' +
    '          {{/hidemobile}} ' +
    '        {{/sublinks}} ' +
    '      {{/hidel2level}} ' +
    '      {{^hidel2level}} ' +
    '        <li class="SimpleFlyout__listItem">' +
    '          <a class="{{linkClassName}}__link"  ' +
    '             href="{{link}}"  ' +
    '             title="{{{title}}}">' +
    '            {{{title}}} ' +
    '          </a>' +
    '        </li>' +
    '      {{/hidel2level}} ' +
    '    {{/links}} ' +
    '    {{#viewAllLink}} ' +
    '      <li class="SimpleFlyout__listItem">' +
    '        <a data-type="direct" ' +
    '           class="SimpleFlyout__link" ' +
    '           href="{{viewAllLink}}" ' +
    '           title="View All">' +
    '          View All {{name}} ' +
    '        </a>' +
    '      </li>' +
    '    {{/viewAllLink}} ' +
    '  </ul>' +
    '</div>';

  // diyHomeServicesHelper
  privateMethods.templates.diyAndHomeServicesLevel3 =
    '<span class="SimpleFlyout__header">' +
    '  {{name}} ' +
    '</span>' +
    '<div class="SimpleFlyout__divider"></div>' +
    '<ul class="SimpleFlyout__list">' +
    '  {{#sublinks}} ' +
    '    <li class="SimpleFlyout__listItem">' +
    '      <a data-type="direct" ' +
    '         class="SimpleFlyout__link" ' +
    '         href="{{link}}" ' +
    '         title="{{{title}}}">' +
    '        {{{title}}} ' +
    '      </a>' +
    '    </li>' +
    '  {{/sublinks}} ' +
    '  {{#viewAllLink}} ' +
    '    <li class="SimpleFlyout__listItem">' +
    '      <a data-type="direct" ' +
    '         class="SimpleFlyout__link" ' +
    '         href="{{viewAllLink}}" ' +
    '         title="View All">' +
    '        View All {{name}} ' +
    '      </a>' +
    '    </li>' +
    '  {{/viewAllLink}} ' +
    '</ul>';


  // constructHomeDecorFurnitureFlyoutLevel1
  privateMethods.templates.homeDecorFurnitureLevel1 =
    '<div id="homeDecorFurnitureLevel1" class="hdfMobile">' +
    '      <span class="SimpleFlyout__header">' +
    '        {{name}} ' +
    '      </span>' +
    '    <div class="SimpleFlyout__divider"></div>' +
    '    <ul class="SimpleFlyout__list">' +
    '        {{#aisles}} ' +
    '            {{#hasBays}} ' +
    '                <li class="hdfMobile SimpleFlyout__listItem">' +
    '                    <a class="hdfMobile SimpleFlyout__link" ' +
    '                       href="{{link}}" ' +
    '                       title="{{name}}">' +
    '                        {{name}} ' +
    '                    </a>' +
    '                </li>' +
    '            {{/hasBays}} ' +
    '            {{^hasBays}} ' +
    '                <li class="hdfMobile SimpleFlyout__listItem">' +
    '                    <a data-type="direct" ' +
    '                       class="hdfMobile SimpleFlyout__link" ' +
    '                       href="{{link}}" ' +
    '                       title="{{name}}">' +
    '                        {{name}} ' +
    '                    </a>' +
    '                </li>' +
    '            {{/hasBays}} ' +
    '        {{/aisles}} ' +
    '    </ul>' +
    '</div>';

  // openSimpleMenuLevel2
  privateMethods.templates.homeDecorFurnitureLevel2 =
    '<div id="homeDecorFurnitureLevel2" class="hdfMobile">' +
    '      <span class="SimpleFlyout__header">' +
    '      {{name}} ' +
    '      </span>' +
    '    <div class="SimpleFlyout__divider"></div>' +
    '    <ul class="SimpleFlyout__list">' +
    '        {{#bays}} ' +
    '            {{#imageURL}} ' +
    '                <li class="hdfMobile SimpleFlyout__listItem" >' +
    '                    <a data-type="direct" ' +
    '                       class="hdfMobile SimpleFlyout__link" ' +
    '                       href="{{link}}" ' +
    '                       title="{{name}}">' +
    '                        <img src="{{imageURL}}" ' +
    '                             alt="{{name}}">' +
    '                    </a>' +
    '                </li>' +
    '            {{/imageURL}} ' +
    '            {{^imageURL}} ' +
    '                {{#hasShelves}} ' +
    '                    <li class="hdfMobile SimpleFlyout__listItem">' +
    '                        <a class="hdfMobile SimpleFlyout__link" ' +
    '                           href="{{link}}" ' +
    '                           title="{{name}}">' +
    '                            {{name}} ' +
    '                        </a>' +
    '                    </li>' +
    '                {{/hasShelves}} ' +
    '                {{^hasShelves}} ' +
    '                    <li class="hdfMobile SimpleFlyout__listItem">' +
    '                        <a data-type="direct" ' +
    '                           class="hdfMobile SimpleFlyout__link" ' +
    '                           href="{{link}}" ' +
    '                           title="{{name}}">' +
    '                            {{name}} ' +
    '                        </a>' +
    '                    </li>' +
    '                {{/hasShelves}} ' +
    '            {{/imageURL}} ' +
    '        {{/bays}} ' +
    '    </ul>' +
    '</div>';

  // openSimpleMenuLevel3
  privateMethods.templates.homeDecorFurnitureLevel3 =
    '<div id="homeDecorFurnitureLevel3" class="hdfMobile">' +
    '  <span class="SimpleFlyout__header">' +
    '    {{name}} ' +
    '  </span>' +
    '  <div class="SimpleFlyout__divider"></div>' +
    '  <ul class="SimpleFlyout__list">' +
    '      {{#shelves}} ' +
    '          <li class="hdfMobile SimpleFlyout__listItem">' +
    '              <a data-type="direct" ' +
    '                 class="hdfMobile SimpleFlyout__link" ' +
    '                 href="{{link}}" ' +
    '                 title="{{name}}">' +
    '                  {{name}} ' +
    '              </a>' +
    '          </li>' +
    '      {{/shelves}} ' +
    '  </ul>' +
    '</div>';

  // openSimpleMenuLevel2
  // openSimpleMenuLevel3
  privateMethods.templates.simpleList =
    '{{#allLink}} ' +
    '  <a href="{{allLink}}">' +
    '    <span class="SimpleFlyout__header">' +
    '      {{name}} ' +
    '    </span>' +
    '  </a>' +
    '{{/allLink}} ' +
    '{{^allLink}} ' +
    '  <span class="SimpleFlyout__header">' +
    '    {{name}} ' +
    '  </span>' +
    '{{/allLink}} ' +
    '<div class="SimpleFlyout__divider"></div>' +
    '<ul class="SimpleFlyout__list">' +
    '  {{#links}} ' +
    '    <li class="SimpleFlyout__listItem">' +
    '      <a class="SimpleFlyout__link" href="{{url}}" title="{{name}}">' +
    '        {{name}} ' +
    '      </a>' +
    '    </li>' +
    '  {{/links}} ' +
    '  {{#allLink}} ' +
    '    <li class="SimpleFlyout__listItem">' +
    '      <a data-type="direct" class="SimpleFlyout__link" href="{{allLink}}" title="View All">' +
    '        View All {{name}} ' +
    '      </a>' +
    '    </li>' +
    '  {{/allLink}} ' +
    '</ul>';

  // renderL1Categories
  privateMethods.templates.level1Flyout =
    '{{#l1}} ' +
    '  {{^hideL1}} ' +
    '    <li class="SimpleFlyout__listItem">' +
    '      <a href="{{link}}" ' +
    '         class="SimpleFlyout__link{{#activeHolidayClass}} SimpleFlyout__link--{{activeHolidayClass}}{{/activeHolidayClass}}" ' +
    '         data-level="{{name}}" ' +
    '         data-image="{{feature.image}}" ' +
    '         data-title="{{feature.title}}" ' +
    '         data-cta="{{feature.cta}}" ' +
    '         data-link="{{feature.link}}" ' +
    '         title="{{name}}">' +
    '        {{name}} ' +
    '      </a>' +
    '    </li>' +
    '  {{/hideL1}} ' +
    '{{/l1}}';

  privateData.homeDecorFurnitureSelectedLevels = [];
  privateData.homeServicesSelectedLevels = [];

  /*
   * Private Methods
   */

  /**
   * Captures the path traversed by the user on click of the headers in L2 and L3.
   * This is used for analytics. And logs the path
   */

  privateMethods.capturePath = function _capturePath() {
    var $this = $(this);
    var path = ['all departments', privateData.selectedLevel1];
    privateData.selectedLevel2 !== undefined && path.push(privateData.selectedLevel2);
    path.push($this.text());
    privateMethods.logEventPath('header click', path);
  };

  privateMethods.clearURL = function _clearURL(urlString) {
    // Need to ensure this value isn't just a placeholder
    // if it is, we need to remove the string so Mustache can tell.
    return urlString === '#' ? '' : urlString;
  };

  privateMethods.closeOnSearchOpen = function _closeOnSearchOpen(event, isOpen) {
    if (isOpen) {
      privateMethods.showSimpleFlyout(event, false);
    }
  };

  privateMethods.constructDIYProjectsIdeasFlyoutLevel1 = function _constructDIYProjectsIdeasFlyoutLevel1(event, response) {
    var panelTitle = $(event.target).text();
    var viewAllURL = $(event.target).attr('href');
    var htmlContent;

    diyProjectsIdeasData = $.extend(true, response);
    diyProjectsIdeasData.diyflyout.name = panelTitle;
    diyProjectsIdeasData.diyflyout.linkClassName = 'diy';
    diyProjectsIdeasData.diyflyout.viewAllLink = viewAllURL;
    htmlContent = Mustache.render(privateMethods.templates.diyAndHomeServicesLevel1, diyProjectsIdeasData.diyflyout);
    $('#simplePanelLevel1 span, #simplePanelLevel1 div.SimpleFlyout__divider:eq(1)').hide();
    $('#simplePanelLevel1').append(htmlContent);
  };

  privateMethods.constructHomeDecorFurnitureFlyoutLevel1 = function _constructHomeDecorFurnitureFlyoutLevel1(event, response) {
    var panelTitle = $(event.target).text().trim();

    homeDecorFurnitureData = response;
    homeDecorFurnitureData.name = panelTitle;

    var htmlContent = Mustache.render(privateMethods.templates.homeDecorFurnitureLevel1, homeDecorFurnitureData);

    $('#simplePanelLevel1 span, #simplePanelLevel1 div.SimpleFlyout__divider:eq(1)').hide();
    $('#simplePanelLevel1').append(htmlContent);

    privateMethods.scrollToTop();
    privateMethods.showSimplePanel(1);
  };

  privateMethods.constructHomeServicesFlyoutLevel1 = function _constructHomeServicesFlyoutLevel1(event, response) {
    var panelTitle = $(event.target).text();
    var viewAllURL = $(event.target).attr('href');
    var htmlContent;

    homeServicesData = $.extend(true, response);
    homeServicesData.hsflyout.name = panelTitle;
    homeServicesData.hsflyout.linkClassName = 'hs';
    homeServicesData.hsflyout.viewAllLink = viewAllURL;
    htmlContent = Mustache.render(privateMethods.templates.diyAndHomeServicesLevel1, homeServicesData.hsflyout);
    $('#simplePanelLevel1 span, #simplePanelLevel1 div.SimpleFlyout__divider:eq(1)').hide();
    $('#simplePanelLevel1').append(htmlContent);
  };

  privateMethods.diyHomeServicesHelper = function _diyHomeServicesHelper(allLinks, level1URL, level1Name) {
    if (allLinks && allLinks.length) {
      allLinks.filter(function (config, index) {
        return config.title === level1Name && config.sublinks;
      }).map(function (currentLink) {
        var htmlContent = Mustache.render(privateMethods.templates.diyAndHomeServicesLevel3, {
          sublinks: currentLink.sublinks,
          name: level1Name,
          viewAllLink: level1URL
        });
        $('#simplePanelLevel2 .SimpleFlyout__container').html(htmlContent);
        privateMethods.scrollToTop();
        privateMethods.showSimplePanel(2);
      });
    }
  };

  privateMethods.handleMenuLevel4 = function _handleMenuLevel4() {
    var $this = $(this);

    if (privateData.homeDecorFurnitureSelectedLevels && privateData.homeDecorFurnitureSelectedLevels[0] === 'home decor and furniture') {
      privateData.homeDecorFurnitureSelectedLevels.push($this.text());
      privateMethods.logHomeDecorFurniturePath('header click');
    } else {
      var level1Name = privateData.selectedLevel1;
      var level2Name = privateData.selectedLevel2;

      privateMethods.logEventPath('header click', ['all departments', level1Name, level2Name, $this.text()]);
    }
  };

  privateMethods.interactWithSimpleMenuLink = function _interactWithSimpleMenuLink(event) {
    var flyoutID = $(event.target).attr('data-id');

    if (flyoutID) {
      event.preventDefault();

      switch (flyoutID) {
      case 'departmentsFlyout':
        privateMethods.showAllDepartmentsFlyout(event);
        break;

      case 'homeDecorFurniture':
        privateMethods.showHomeDecorFurnitureFlyout(event);
        break;

      case 'diyProjectsIdeas':
        privateMethods.showDIYProjectsIdeasFlyout(event);
        break;

      case 'homeServices':
        privateMethods.showHomeServicesFlyout(event);
        break;

      default:
        break;
      }
    }
  };

  privateMethods.logEventPath = function _logEventPath(type, pathArray) {
    pathArray.forEach(function _reformatLevels(level, index) {
      pathArray[index] = level.replace('&', 'and').toLowerCase().trim();
    });
    // Get header at the beginning, then join them all
    return headerAnalytics.logEvent(type, ['header'].concat(pathArray).join('>'));
  };

  privateMethods.logEventPathL3Link = function _logEventPathL3Link(event) {
    var l3LinkText = $(this).text().replace('&', 'and').toLowerCase().trim();
    var l2ClassName = event.target.attributes.class.value;

    if (!l2ClassName.includes('homedecor__link')) {
      var checkLevelOne = l1Name.toLowerCase().trim();
      if (checkLevelOne !== 'home decor and furniture' && checkLevelOne !== 'all departments') {
        privateMethods.logEventPath('header click', [l1Name, l2Name, l3LinkText]);
      }
    }
  };

  privateMethods.logEventPathTaskLink = function _logEventPathTaskLink(event) {
    var taskLinkText = $(this).text().replace('&', 'and').toLowerCase().trim();
    l1Name = taskLinkText;
    privateMethods.logEventPath('header click', [taskLinkText]);
  };

  privateMethods.logHomeDecorFurniturePath = function _logHomeDecorFurniturePath(type) {
    var analyticsPathArray = [];
    privateData.homeDecorFurnitureSelectedLevels.forEach(function _generateAnalyticsPathArray(level) {
      analyticsPathArray.push(level.replace('&', 'and').toLowerCase().trim());
    });
    return headerAnalytics.logEvent(type, ['header'].concat(analyticsPathArray).join('>'));
  };

  privateMethods.notifyMenuState = function _notifyMenuState(state) {
    // Use a namespaced event, pass along the state
    $(document).trigger('menuState', [{
      isOpen: state,
      menu: 'simple'
    }]);
  };

  privateMethods.openDiyHsMenuLevel2 = function _openDiyHsMenuLevel2(event) {
    var $this = $(this);
    var level1URL = $this.attr('href');
    var level1Name = $this.text().trim();
    var level1Class = $this.attr('class');
    var allLinks;

    if (($this.data('type') !== 'direct')) {
      event.preventDefault();
      event.stopPropagation();

      // if class is diy__link pass DIY Flyout data
      if (level1Class.indexOf('diy__link') !== -1) {
        allLinks = diyProjectsIdeasData.diyflyout.links;
      } else if (level1Class.indexOf('hs__link') !== -1) {
        privateData.homeServicesSelectedLevels.push(level1Name);
        allLinks = homeServicesData.hsflyout.links;
      }

      privateMethods.diyHomeServicesHelper(allLinks, level1URL, level1Name);
      l2Name = level1Name;
      if (!$this.hasClass('homedecor__link')) {
        privateMethods.logEventPath('header click', [l1Name, level1Name]);
      }
    } else {
      privateMethods.logEventPath('header click', [level1Name, $(event.target).text()]);
    }
  };

  privateMethods.openSimpleMenuLevel2 = function _openSimpleMenuLevel2(event) {
    var $this = $(this);
    var level1Name = $this.text();

    event.preventDefault();

    var htmlContent;

    if ($this.hasClass('hdfMobile')) {
      // Home Decor & Furniture
      // At this moment, the user is on panel level 1 which displays all of the aisles

      privateData.homeDecorFurnitureSelectedLevels.push(level1Name);

      homeDecorFurnitureData.name = level1Name.trim();

      var aisle;
      homeDecorFurnitureData.aisles.forEach(function _findAisle(element) {
        if (element.name === homeDecorFurnitureData.name) {
          aisle = element;
        }
      });

      // If the aisle has bays, move to the next panel with bays
      // Else, redirect to the aisle page
      if (aisle.hasBays) {
        homeDecorFurnitureData.bays = aisle.bays;

        htmlContent = Mustache.render(privateMethods.templates.homeDecorFurnitureLevel2, aisle);
        $('#simplePanelLevel2 .SimpleFlyout__container').html(htmlContent);
        privateMethods.scrollToTop();
        privateMethods.showSimplePanel(2);
      } else {
        privateMethods.logHomeDecorFurniturePath('header click')
          .then(function _redirectToAislePage() {
            // Go where we were going any way
            privateMethods.setLocation(aisle.link);
          });
      }
    } else {
      // All Departments
      var level1Data = $this.data();
      var level1URL = $this.attr('href');

      var departmentName = 'all departments';
      if ($this.hasClass('SimpleFlyout__link-home-decor') || $this.hasClass('homedecor__image')) {
        departmentName = 'home decor and furniture';
      }

      if ($this.hasClass('homedecor__image')) {
        privateMethods.logEventPath('header click', [departmentName, level1Name])
          .then(function _level2LogComplete() {
            // Go where we were going any way
            privateMethods.setLocation($this.children()[0].href);
          });
      } else {
        privateData.selectedLevel1 = level1Data.level;

        var requestLevel2Data = headerData.getLevel2Data(level1Data.level);

        // If it worked
        requestLevel2Data.then(function _renderLevel2Data(level2Data) {
          htmlContent = Mustache.render(privateMethods.templates.simpleList, {
            links: level2Data,
            allLink: privateMethods.clearURL(level1URL),
            name: level1Name
          });

          $('#simplePanelLevel2 .SimpleFlyout__container').html(htmlContent);
          privateMethods.scrollToTop();
          privateMethods.showSimplePanel(2);
        });

        // If it failed
        requestLevel2Data.fail(function _level2DataLoadFailed() {
          privateMethods.logEventPath('header click', [departmentName, level1Name])
            .then(function _level2LogComplete() {
              // Go where we were going any way
              privateMethods.setLocation(level1URL);
            });
        });
        requestLevel2Data.done(function _level2DataLoadSuccess() {
          privateMethods.logEventPath('header click', [departmentName, level1Name]);
        });
      }
    }
  };

  privateMethods.openSimpleMenuLevel3 = function _openSimpleMenuLevel3(event) {
    var $this = $(this);
    var level1Name = privateData.selectedLevel1;
    var level2Name = $this.text().trim();

    privateData.selectedLevel2 = level2Name;

    // If this is not a direct link
    if (($this.data('type') !== 'direct')) {
      event.preventDefault();

      var htmlContent;

      if ($this.hasClass('hdfMobile')) {
        // Home Decor & Furniture
        privateData.homeDecorFurnitureSelectedLevels.push(level2Name);

        homeDecorFurnitureData.name = level2Name.trim();

        var bay;
        homeDecorFurnitureData.bays.forEach(function _findBay(element) {
          if (element.name === homeDecorFurnitureData.name) {
            bay = element;
          }
        });

        htmlContent = Mustache.render(privateMethods.templates.homeDecorFurnitureLevel3, bay);

        $('#simplePanelLevel3 .SimpleFlyout__container').html(htmlContent);
        privateMethods.scrollToTop();
        privateMethods.showSimplePanel(3);
      } else {
        // All Departments
        var level2URL = $this.attr('href');

        // request the data
        var requestLevel3Data = headerData.getLevel3Data(level1Name, level2Name);

        // If it worked
        requestLevel3Data.then(function _renderLevel3Data(level3Data) {
          // render this thing
          htmlContent = Mustache.render(privateMethods.templates.simpleList, {
            links: level3Data,
            allLink: privateMethods.clearURL(level2URL),
            name: level2Name
          });

          // put it in the DOM
          $('#simplePanelLevel3 .SimpleFlyout__container').html(htmlContent);
          privateMethods.scrollToTop();
          // Show the panel
          privateMethods.showSimplePanel(3);
        });

        // If it failed - could be that the index doesn't exist, or that its got no results
        requestLevel3Data.fail(function _level3DataLoadFailed() {
          privateMethods.logEventPath('header click',
            ['all departments',
              level1Name,
              level2Name])
            .then(function _level3LogComplete() {
              // Go where we were going any way
              window.location = level2URL;
            });
        });

        requestLevel3Data.done(function _level3DataLoadSuccess() {
          privateMethods.logEventPath('header click', ['all departments', level1Name, level2Name]);
        });
      }
    } else {
      // This is a direct link so log it now
      if ($this.hasClass('hdfMobile')) {
        var analyticsSelectedBay = level2Name.trim() === '' ? 'catalog image' : level2Name;
        privateData.homeDecorFurnitureSelectedLevels.push(analyticsSelectedBay);
        privateMethods.logHomeDecorFurniturePath('header click');
      } else if (privateData.homeServicesSelectedLevels && privateData.homeServicesSelectedLevels[0] === 'home services') {
        privateData.homeServicesSelectedLevels.push(level2Name);
      } else {
        privateMethods.logEventPath('header click', ['all departments', level1Name, level2Name]);
      }
    }
  };

  privateMethods.preventMaskClose = function _preventMaskClose(event) {
    event.stopPropagation();
  };

  privateMethods.renderL1Categories = function _renderL1Categories() {
    var requestLevel1Data = headerData.getLevel1Data();
    requestLevel1Data.then(function _renderLevel1Data(level1Data) {
      var htmlContent = Mustache.render(privateMethods.templates.level1Flyout, {l1: level1Data});
      $('#simplePanelLevel1 ul.SimpleFlyout__list').empty().html(htmlContent);
    });
  };

  privateMethods.scrollToTop = function _scrollToTop() {
    $(window).scrollTop(0);
  };

  privateMethods.setLocation = function _setLocation(url) {
    window.location = url;
  };

  privateMethods.showAllDepartmentsFlyout = function _showAllDepartmentsFlyout(event) {
    // Do not redirect the user to href link
    if ($(event.target).data('type') !== 'direct') {
      event.preventDefault();
      $('.diyandhs').remove();
      $('.hdfMobile').remove();
      $('#simplePanelLevel1 .SimpleFlyout__list').show();
      $('#simplePanelLevel1 span, #simplePanelLevel1 div.SimpleFlyout__divider:eq(1)').show();
      privateMethods.scrollToTop();
      privateMethods.showSimplePanel(1);
      $(document).trigger('closeHeaderTooltips');
    } else {
      // the below log event needs to be in an else block
      privateMethods.logEventPath('header click', ['all departments', $(event.target).text()]);
    }
  };

  privateMethods.showDIYProjectsIdeasFlyout = function _showDIYProjectsIdeasFlyout(event) {
    var jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/diyflyout.json';
    var level1Name = $(event.target).text();
    var panelTitle = $(event.target).text();

    // do not redirect the user to href link
    if ($(event.target).data('type') !== 'direct') {
      event.preventDefault();

      $('.diyandhs').remove();
      $('#simplePanelLevel1 .SimpleFlyout__list').hide();

      // Only make a call if diyProjectsIdeasData is not available
      if (!diyProjectsIdeasData.hasOwnProperty('diyflyout')) {
        headerData.getEtchJSON(jsonPath)
          .then(privateMethods.constructDIYProjectsIdeasFlyoutLevel1.bind(null, event));
      } else {
        privateMethods.constructDIYProjectsIdeasFlyoutLevel1(event, diyProjectsIdeasData);
      }
      privateMethods.scrollToTop();
      privateMethods.showSimplePanel(1);
      $(document).trigger('closeHeaderTooltips');
    } else { // redirect the user to href link & log the details
      privateMethods.logEventPath('header click', [level1Name, panelTitle]);
    }
  };

  privateMethods.showHomeDecorFurnitureFlyout = function _showHomeDecorFurnitureFlyout(event) {
    privateData.homeDecorFurnitureSelectedLevels.push('home decor and furniture');

    // do not redirect the user to href link
    if ($(event.target).data('type') !== 'direct') {
      event.preventDefault();

      $('.hdfMobile').remove();
      $('#simplePanelLevel1 .SimpleFlyout__list').hide();

      // Only make a call if aisles is not available
      if (!homeDecorFurnitureData.hasOwnProperty('aisles')) {
        var jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/homeDecorFurnitureFlyout.json';
        var responseDataPromise = headerData.getEtchJSON(jsonPath);

        responseDataPromise.then(function _responseDataPromise(homeDecorFurnitureFlyoutData) {
          homeDecorFurnitureData = homeDecorFurnitureFlyoutData;

          if (homeDecorFurnitureData && homeDecorFurnitureData.aisles) {
            homeDecorFurnitureData.aisles.forEach(function _rebuildAislesForMobile(aisle) {
              if (aisle.columns && aisle.columns.length !== 0) {
                aisle.bays = [];
                aisle.columns.forEach(function _replaceColumnsWithBays(column) {
                  if (column.bays && column.bays.length !== 0) {
                    column.bays.forEach(function _determineHasShelves(bay) {
                      bay.hasShelves = bay.shelves && bay.shelves.length !== 0;
                      aisle.bays.push(bay);
                    });
                  }
                });
              }
              if (aisle.name === 'Shop by Room') {
                aisle.bays.forEach(function _reformatShopByRoomBay(bay) {
                  bay.imageURL = null;
                });
              }
              aisle.hasBays = aisle.bays && aisle.bays.length !== 0;
            });
          }

          privateMethods.constructHomeDecorFurnitureFlyoutLevel1(event, homeDecorFurnitureData);
          $(document).trigger('closeHeaderTooltips');
        });
      } else {
        privateMethods.constructHomeDecorFurnitureFlyoutLevel1(event, homeDecorFurnitureData);
        $(document).trigger('closeHeaderTooltips');
      }
    } else { // redirect the user to href link & log the details
      var panelTitle = $(event.target).text();
      privateMethods.logEventPath('header click', [panelTitle]);
    }
  };

  privateMethods.showHomeServicesFlyout = function _showHomeServicesFlyout(event) {
    privateData.homeServicesSelectedLevels.push('home services');

    var jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/hsflyout.json';
    var level1Name = $(event.target).text();
    var panelTitle = $(event.target).text();

    // Do not redirect the user to href link
    if ($(event.target).data('type') !== 'direct') {
      event.preventDefault();
      $('.diyandhs').remove();
      $('#simplePanelLevel1 .SimpleFlyout__list').hide();

      // Only make a call if homeServicesData is not available
      if (!homeServicesData.hasOwnProperty('hsFlyout')) {
        headerData.getEtchJSON(jsonPath)
          .then(privateMethods.constructHomeServicesFlyoutLevel1.bind(null, event));
      } else {
        privateMethods.constructHomeServicesFlyoutLevel1(event, homeServicesData);
      }
      privateMethods.scrollToTop();
      privateMethods.showSimplePanel(1);
      $(document).trigger('closeHeaderTooltips');
    } else { // redirect the user to href link & log the details
      privateMethods.logEventPath('header click', [level1Name, panelTitle]);
    }
  };

  privateMethods.showSimpleFlyout = function _showSimpleFlyout(event, open) {
    var menuShown = (typeof open === 'undefined') ? true : open;
    var $button = $('#simpleMenuButton');

    privateMethods.notifyMenuState(menuShown);

    // toggle the menu state
    $('#simpleFlyout').toggleClass('SimpleFlyout--closed', !menuShown);

    // Toggle the button state... its complicated
    $button.find('.SimpleMenu__close').toggleClass('SimpleMenu__close--open', menuShown);
    $button.find('.SimpleMenu__menu').toggleClass('SimpleMenu__menu--closed', menuShown);

    // reset the panel to the beginning
    privateData.homeDecorFurnitureSelectedLevels = [];
    privateData.homeServicesSelectedLevels = [];
    privateMethods.showSimplePanel(0);
    headerMask.show();

    if (menuShown) {
      // close the tooltips in case they are open
      $(document).trigger('closeHeaderTooltips');
      $(document).trigger('closeAllMenus');
      // show the masking layer if appropriate
      $(document).trigger('headerMask-show', menuShown);
    } else {
      $(document).trigger('headerMask-show', menuShown);
    }
  };

  privateMethods.showSimplePanel = function _showSimplePanel(level) {
    var thisLevel = parseInt(level, 10);

    $('#simpleFlyout').find('.SimpleFlyout__wrapper')
      .toggleClass('SimpleFlyout__wrapper--level1', (thisLevel === 1))
      .toggleClass('SimpleFlyout__wrapper--level2', (thisLevel === 2))
      .toggleClass('SimpleFlyout__wrapper--level3', (thisLevel === 3));
  };

  privateMethods.simpleMenuBack = function _simpleMenuBack(event) {
    if (event && event.type === 'touchend') {
      // Prevent default to stop click firing for touch events
      event.preventDefault();
    }
    privateMethods.scrollToTop();

    privateData.homeDecorFurnitureSelectedLevels.pop();

    // strangely, event is explicitly needed for FF but not for others...
    privateMethods.showSimplePanel($(event.target).data('level'));
  };

  privateMethods.toggleSimpleFlyout = function _toggleSimpleFlyout(event) {
    var $simpleMenu = $('#simpleFlyout');
    var simpleMenuOpen = !(!$simpleMenu.hasClass('SimpleFlyout--closed'));

    event.preventDefault();
    event.stopPropagation();

    privateMethods.showSimpleFlyout(event, simpleMenuOpen);
  };

  // bind to all the necessary elements
  privateMethods.initialize = function initialize() {
    // delegate to all the things
    $(document)
      .on('click touchend', '#simpleFlyout', privateMethods.preventMaskClose)
      .on('click touchend', '#simpleFlyout .SimpleFlyout__back', privateMethods.simpleMenuBack)
      .on('click touchend', '#simpleMenuButton', privateMethods.toggleSimpleFlyout)
      .on('click touchend', '#simplePanelLevel2 .SimpleFlyout__header', privateMethods.capturePath)
      .on('click touchend', '#simplePanelLevel3 .SimpleFlyout__header', privateMethods.capturePath)
      .on('click', '#diyhslevel2 .diy__link, #diyhslevel2 .hs__link, #diyhslevel2 .homedecor__link', privateMethods.openDiyHsMenuLevel2)
      .on('click', '#simplePanelLevel1 .SimpleFlyout__link', privateMethods.openSimpleMenuLevel2)
      .on('click', '#simplePanelLevel1 .homedecor__image', privateMethods.openSimpleMenuLevel2)
      .on('click', '#simplePanelLevel2 .SimpleFlyout__link', privateMethods.openSimpleMenuLevel3)
      .on('click', '#simplePanelLevel2 .SimpleFlyout__container .SimpleFlyout__list li.SimpleFlyout__listItem a.SimpleFlyout__link, #diyhslevel2 .homedecor__link', privateMethods.logEventPathL3Link)
      .on('click', '#simplePanelLevel3 .SimpleFlyout__link', privateMethods.handleMenuLevel4)
      .on('click', '#simplePanelMain', privateMethods.interactWithSimpleMenuLink)
      .on('click', '#simplePanelMain .SimpleFlyout__list li.SimpleFlyout__listItem a.SimpleFlyout__link', privateMethods.logEventPathTaskLink)
      .on('searchState', privateMethods.closeOnSearchOpen)
      .on('showSimpleFlyout', privateMethods.showSimpleFlyout);
  };

  /*
   * Public Methods
   */

  flyout.init = function init() {
    // Do it before ready - cause we rock
    privateMethods.initialize();

    // Start loading the data now
    headerData.init();

    // Render the L1 Categories
    if (THD_GLOBAL.flyoutVersion === '8') {
      privateMethods.renderL1Categories();
    }

    return this;
  };

  flyout.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  return flyout;
});
